import React, { useEffect, useState } from "react"
import Requests from "./requests"
import Breadcrumb from "components/Common/Breadcrumb"
import Skeleton from "react-loading-skeleton"
import TrackingRouteMap from "pages/Tracking/TrackingRouteMap"
import OnlineDrivers from "./onlineDrivers"
import { toast } from "react-toastify"
import axios from "axios"

const Tracking = () => {
  const [booking, setBooking] = useState(null)
  const [drivers, setDrivers] = useState([])
  const [loading, setLoading] = useState(false)
  const token = localStorage.getItem("authToken")

  useEffect(() => {
    const fetchDrivers = async () => {
      if (booking) {
        setLoading(true)
        try {
          const token = localStorage.getItem("authToken")
          const response = await axios.get(
            `${process.env.REACT_APP_WEB_APP_URL}/api/web/booking-requests/${booking?.booking?.id}/nearby-drivers`,
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          )
          if (response.status === 200) {
            const apiDrivers = response?.data?.data?.drivers
            setDrivers(apiDrivers)
          } else {
            toast.error("Error fetching online drivers")
          }
        } catch (error) {
          toast.error(error.message || "Error fetching online drivers")
          setDrivers([])
        } finally {
          setLoading(false)
        }
      }
    }
    fetchDrivers()
  }, [booking])

  // Poll for driver updates every 5 seconds
  useEffect(() => {
    if (!booking) return;
    const token = localStorage.getItem("authToken")
    const intervalId = setInterval(async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_WEB_APP_URL}/api/web/booking-requests/${booking?.booking?.id}/nearby-drivers`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        )
        if (response.status === 200) {
          const apiDrivers = response?.data?.data?.drivers
          setDrivers(apiDrivers)
        }
      } catch (error) {
        // Optionally handle error
      }
    }, 5000)
    return () => clearInterval(intervalId)
  }, [booking])

  document.title = "Tracking | Moeen Portal"
  return (
    <div className="page-content">
      <Breadcrumb title="Home" breadcrumbItem="Tracking" />
      <div className="position-relative">
        <TrackingRouteMap
          booking={booking?.booking}
          loading={loading}
          drivers={drivers}
        />

        {/* Requests panel (left side) */}
        <Requests setBooking={setBooking} />

        {/* Online drivers panel (top-right side) */}
        {booking && <OnlineDrivers loading={loading} drivers={drivers} />}
      </div>
    </div>
  )
}

export default Tracking